import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "timi-machine-container" }
const _hoisted_2 = { class: "timi-machine-detail-content" }
const _hoisted_3 = { class: "timi-detail-column column-33" }
const _hoisted_4 = { class: "ww-data-list-item" }
const _hoisted_5 = { class: "list-item-small-text" }
const _hoisted_6 = { class: "ww-data-list-item" }
const _hoisted_7 = { class: "list-item-small-text" }
const _hoisted_8 = {
  key: 0,
  class: "ww-data-list-item"
}
const _hoisted_9 = { class: "list-item-small-text" }
const _hoisted_10 = {
  key: 1,
  class: "ww-data-list-item"
}
const _hoisted_11 = { class: "list-item-small-text" }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { class: "ww-card-actions" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "timi-detail-column column-33" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconButton = _resolveComponent("IconButton")!
  const _component_DataList = _resolveComponent("DataList")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_IconButton, {
      icon: _ctx.store.getters.svgIcons.arrowbackward,
      class: "go-back-btn",
      label: _ctx.$t('button.back'),
      dense: true,
      onOnClick: _ctx.handleGoBack
    }, null, 8, ["icon", "label", "onOnClick"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_Card, {
          title: _ctx.$t('label.machine')
        }, {
          default: _withCtx(() => [
            (_ctx.machine)
              ? (_openBlock(), _createBlock(_component_DataList, { key: 0 }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_4, [
                      _createElementVNode("h4", null, _toDisplayString(_ctx.$t('label.label')), 1),
                      _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.machine.title), 1)
                    ]),
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("h4", null, _toDisplayString(_ctx.$t('label.number')), 1),
                      _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.machine.number), 1)
                    ]),
                    (_ctx.machine.department)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                          _createElementVNode("h4", null, _toDisplayString(_ctx.$t('label.department')), 1),
                          _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.machine.department.title), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.machine.workarea)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                          _createElementVNode("h4", null, _toDisplayString(_ctx.$t('label.workarea')), 1),
                          _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.machine.workarea.title), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }))
              : (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(_ctx.$t('emptyState.default')), 1)),
            _createElementVNode("div", _hoisted_13, [
              _createVNode(_component_Button, {
                text: _ctx.$t('button.edit'),
                dense: true,
                onOnClick: _ctx.handleEdit
              }, null, 8, ["text", "onOnClick"]),
              _createVNode(_component_Button, {
                text: _ctx.$t('button.delete'),
                dense: true,
                onOnClick: _ctx.handleConfirmDeleteMachine
              }, null, 8, ["text", "onOnClick"])
            ])
          ]),
          _: 1
        }, 8, ["title"])
      ]),
      _hoisted_14
    ])
  ]))
}